import React from "react";
import * as Styles from "../../../../common-deprecated/styles/v2/toyota/components/Form";
import { IconExclamation } from "../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import {
    type TradeInAemContactTextIdType,
    type TradeInAemTextInputType,
    TradeInAemContactFormId,
} from "../../../utils/constants";
import { type TradeInAemDispatchType, useTradeInAemSelector } from "../../../redux/store";
import useValidatedTextField from "../../../../common-deprecated/hooks/useValidatedTextField";
import { setTradeInAemContactTextValue } from "../../../redux/actions/TradeInAemContactFormActions";
import { useTradeInAemLabel } from "../../../utils/labels";
import { useDispatch } from "../../../../shared-logic/redux/store";

type Props = { formItemId: TradeInAemContactTextIdType; showRequiredError?: boolean };

const ContactFormTextField = ({ formItemId, showRequiredError = false }: Props): JSX.Element | null => {
    const formItem: TradeInAemTextInputType | undefined = useTradeInAemSelector(
        (state) => state.tradeInAemContact[formItemId],
    );
    const [requiredLabel, emailErrorLabel] = useTradeInAemLabel([
        "tradeInAemFieldRequired",
        "tradeInAemContactEmailError",
    ]);
    const dispatch = useDispatch<TradeInAemDispatchType>();

    const { errorMessage, value, setValue } = useValidatedTextField(
        (formItem?.value as string) || "",
        (newValue) => dispatch(setTradeInAemContactTextValue(formItemId, newValue)),
        {
            showRequiredError,
            requiredLabel,
            validationRule: formItem?.validator?.regex,
            validationError: formItem?.validator?.errorMessage,
            required: formItem?.required,
            isEmail: formItemId === TradeInAemContactFormId.Email,
            emailValidationError: emailErrorLabel,
        },
    );

    if (!formItem) return null;

    const { placeholder, required, label, description } = formItem;

    return (
        <>
            <Styles.InputField hasError={!!errorMessage}>
                <Styles.InputLabel htmlFor={formItemId}>
                    {label}
                    {required && <Styles.MandatoryField>*</Styles.MandatoryField>}
                </Styles.InputLabel>
                <Styles.Input>
                    <input
                        id={formItemId}
                        type={formItemId === TradeInAemContactFormId.Email ? "email" : "text"}
                        placeholder={placeholder}
                        required={required}
                        value={value || ""}
                        onChange={(evt) => setValue(evt.target.value)}
                    />
                </Styles.Input>
            </Styles.InputField>
            {description && <Styles.HelpText>{description}</Styles.HelpText>}
            {errorMessage && (
                <Styles.ErrorField>
                    <span>{errorMessage}</span>
                    <IconWrapper iconColor="primaryRed">
                        <IconExclamation />
                    </IconWrapper>
                </Styles.ErrorField>
            )}
        </>
    );
};

export default ContactFormTextField;
